/**
 * Utility for handling clickable-card components after rehydration
 */

/**
 * Checks if click occurs on an interactive element
 * @param {Element} target - The click target element
 * @returns {boolean}
 */
var isClickOnInteractiveElement = function isClickOnInteractiveElement(target) {
  var interactiveTags = ["A", "BUTTON", "INPUT", "SELECT", "TEXTAREA"];
  var interactiveRoles = ["button", "link", "tab", "option"]; // Check the element itself and its parents

  var element = target;

  while (element && element !== document.body) {
    // Check tag name
    if (interactiveTags.includes(element.tagName)) {
      return true;
    } // Check role attribute


    var role = element.getAttribute("role");

    if (role && interactiveRoles.includes(role)) {
      return true;
    } // Check if element has event handlers


    if (element.hasAttribute("onclick") || element.onclick) {
      return true;
    }

    element = element.parentElement;
  }

  return false;
};
/**
 * Performs navigation to the specified URL
 * @param {string} href - URL for navigation
 * @param {string} target - Target for opening (_self, _blank, etc.)
 */


var navigateToUrl = function navigateToUrl(href, target) {
  if (target === "_blank") {
    window.open(href, target, "noopener,noreferrer");
  } else {
    window.location.href = href;
  }
};
/**
 * Adds click handler to a specific card
 * @param {Element} card - Card element
 */


export var addClickHandlerToCard = function addClickHandlerToCard(card) {
  var href = card.getAttribute("data-href");
  var target = card.getAttribute("data-target") || "_self"; // Check if card has href and handler is not already added

  if (!href || card.hasAttribute("data-click-handler-added")) {
    return;
  }

  var handleClick = function handleClick(event) {
    // Check if click is not on an interactive element inside the card
    if (isClickOnInteractiveElement(event.target)) {
      return;
    }

    event.preventDefault();
    navigateToUrl(href, target);
  }; // Add event handler


  card.addEventListener("click", handleClick); // Mark that handler was already added

  card.setAttribute("data-click-handler-added", "true"); // Add styles to indicate clickability

  if (!card.style.cursor) {
    card.style.cursor = "pointer";
  }
};
/**
 * Adds click handlers for all elements with clickable-card class
 * @param {Element} container - Container to search for clickable-card elements
 */

export var setupClickableCards = function setupClickableCards(container) {
  if (!container) {
    return;
  }

  var clickableCards = container.querySelectorAll(".clickable-card[data-href]");
  clickableCards.forEach(function (card) {
    addClickHandlerToCard(card);
  });
};
/**
 * Removes click handlers from clickable-card elements
 * @param {Element} container - Container with cards
 */

export var cleanupClickableCards = function cleanupClickableCards(container) {
  if (!container) {
    return;
  }

  var clickableCards = container.querySelectorAll(".clickable-card[data-click-handler-added]");
  clickableCards.forEach(function (card) {
    card.removeAttribute("data-click-handler-added");
    card.style.cursor = "";
  });
};
export default {
  setupClickableCards: setupClickableCards,
  addClickHandlerToCard: addClickHandlerToCard,
  cleanupClickableCards: cleanupClickableCards
};